function formatCurrency(money) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })

  return formatter.format(money)
}

if (!customElements.get("quick-view-modal")) {
  customElements.define(
    "quick-view-modal",
    class extends HTMLElement {
      constructor() {
        super()

        this.overlay = this.querySelector(".component-dialog__overlay")
        this.content = this.querySelector(".component-dialog__content")
        this.body = this.querySelector(".component-dialog__body")

        //Close Button
        this.closeButton = this.querySelector(".component-dialog__close")
        if (this.closeButton) {
          this.closeButton.addEventListener("click", this.close.bind(this))
        }

        // Wait for button click
        document.addEventListener("click", (e) => {
          if (e.target.classList.contains("product-card__quick-view")) {
            e.preventDefault()
            this.getProductData(e.target.getAttribute("data-product-handle"))
            this.open()
          }
        })
      }

      open() {
        this.setAttribute("data-state", "open")
        this.content.setAttribute("data-state", "open")
        this.overlay.setAttribute("data-state", "open")
        this.isOpen = true

        document.body.classList.add("component-dialog-open")
      }

      close() {
        this.setAttribute("data-state", "closing")
        this.content.setAttribute("data-state", "closing")
        this.overlay.setAttribute("data-state", "closing")

        document.body.classList.remove("component-dialog-open")

        this.content.addEventListener(
          "animationend",
          () => {
            this.setAttribute("data-state", "closed")
            this.content.setAttribute("data-state", "closed")
            this.overlay.setAttribute("data-state", "closed")
            this.isOpen = false
          },
          { once: true },
        )
      }

      getProductData(handle, variantId) {
        if (!handle) {
          console.log("No product found")
          return
        }

        let fetchUrl = `/products/${handle}?section_id=product-quick-view`

        if (variantId) {
          fetchUrl += `&variant=${variantId}`
        }

        fetch(fetchUrl)
          .then((res) => res.text())
          .then((state) => {
            const parser = new DOMParser()
            const html = parser.parseFromString(state, "text/html")

            const source = html.querySelector("#shopify-section-product-quick-view")
            const destination = this.body

            if (source && destination) destination.innerHTML = source.innerHTML

            // Execute scripts
            const scripts = source.querySelectorAll("script")
            scripts.forEach((script) => {
              const scriptFunction = new Function(script.textContent)
              scriptFunction()
            })
          })
      }
    },
  )
}

if (!customElements.get("quick-view-select")) {
  customElements.define(
    "quick-view-select",
    class extends HTMLElement {
      constructor() {
        super()

        this.addEventListener("change", this.onVariantChange)
      }

      onVariantChange() {
        this.updateOptions()
        this.updateMasterId()

        if (!this.currentVariant) {
          console.log("no variant")
        } else {
          this.renderProductInfo()
        }
      }

      updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (select) => select.value)
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option
            })
            .includes(false)
        })
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id
        const handle = this.dataset.handle

        const subRadio = document.querySelector("quick-view-subscription")
        const isSub = (subRadio && subRadio.isSub()) || false

        let fetchUrl = `/product/${handle}?section_id=product-quick-view`

        if (requestedVariantId) {
          fetchUrl += `&variant=${requestedVariantId}`
        }

        if (isSub) {
          const frequencyId = subRadio.querySelector('select[name="selling_plan"]').value
          fetchUrl += `&selling_plan=${frequencyId}`
        }

        console.log("FETCH URL 2:")
        console.log(fetchUrl)

        document.querySelector("quick-view-modal").getProductData(handle, requestedVariantId)
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return this.variantData
      }
    },
  )
}

if (!customElements.get("quick-view-subscription")) {
  customElements.define(
    "quick-view-subscription",
    class extends HTMLElement {
      constructor() {
        super()

        this.cachedSellingPlanID = ""
        this.mainRadio = this.querySelectorAll(".quick-view__subscription")
        this.mainRadio.forEach((radio) => {
          radio.addEventListener("click", () => this.toggleSubRadio(radio))
        })

        // Call toggleSubContent when the component is loaded
        this.toggleSubContent()
      }

      toggleSubRadio(selected) {
        this.mainRadio.forEach((btn) => {
          btn.classList.remove("current-frequency")
        })

        selected.classList.add("current-frequency")

        this.toggleSubContent()
      }

      toggleSubContent() {
        const isSub = this.isSub()
        const select = this.querySelector('select[name="selling_plan"]')

        const priceElement = document.querySelector(".quick-view .btn-price")
        const compareElement = document.querySelector(".quick-view .compare_at")

        //Set cache Select Value
        if (select.value) {
          this.cachedSellingPlanID = select.value
        }

        if (isSub) {
          this.querySelector(".quick-view__frequency-benefits").classList.remove("hidden")
          this.querySelector(".quick-view__selector").classList.add("hidden")

          // Remove on time option
          const option = select.querySelector('option[value=""]')
          if (option) option.remove()

          // Select the option with the same cachedSellingPlanID
          if (this.cachedSellingPlanID !== "") {
            const cachedOption = Array.from(select.options).find((option) => option.value === this.cachedSellingPlanID)
            if (cachedOption) {
              cachedOption.selected = true
            }
          }

          // Price Changes
          const price = parseFloat(priceElement.getAttribute("data-price"))
          const compare = compareElement.getAttribute("data-compare-price")

          if (compare === "") {
            compareElement.innerText = formatCurrency(price)
          }

          const newPrice = price * 0.85
          priceElement.innerText = formatCurrency(newPrice)
        } else {
          this.querySelector(".quick-view__frequency-benefits").classList.add("hidden")
          this.querySelector(".quick-view__selector").classList.remove("hidden")

          // Add one time option
          const oneTimeOption = document.createElement("option")
          oneTimeOption.value = ""
          oneTimeOption.text = "One Time"
          oneTimeOption.selected = true // Make this option selected by default
          select.add(oneTimeOption)

          // Price Changes
          const price = parseFloat(priceElement.getAttribute("data-price"))
          const compare = compareElement.getAttribute("data-compare-price")

          if (compare === "") {
            compareElement.innerText = ``
          }

          priceElement.innerText = formatCurrency(price)
        }
      }

      isSub() {
        const label = this.querySelector(".quick-view__subscription.current-frequency").getAttribute("data-label")
        return label !== "one-time"
      }
    },
  )
}

if (!customElements.get("quick-view-size")) {
  customElements.define(
    "quick-view-size",
    class extends HTMLElement {
      constructor() {
        super()
        this.addEventListener("change", this.onChange)
      }

      onChange() {
        this.options = Array.from(this.querySelectorAll("input")).find((radio) => radio.checked).value
        this.updateSelectSize(this.options)
        document.querySelector("quick-view-select").onVariantChange()
      }

      updateSelectSize(size) {
        const variantSelector = document.querySelector("quick-view-select")
        const selectElement =
          variantSelector.querySelector('select[name="options[Size]"]') ||
          variantSelector.querySelector('select[name="options[Quantity]"]')

        selectElement.value = size
      }
    },
  )
}

if (!customElements.get("quick-view-form")) {
  customElements.define(
    "quick-view-form",
    class extends HTMLElement {
      constructor() {
        super()
        this.form = this.querySelector("form")
        if (!this.form) return

        this.form.querySelector("[name='id']").disabled = false
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))

        this.cartDrawer = document.querySelector("cart-drawer")
        this.modal = document.querySelector("quick-view-modal")
      }

      onSubmitHandler(event) {
        event.preventDefault()

        const btn = this.querySelector('[type="submit"]')

        btn.setAttribute("aria-disabled", true)
        btn.classList.add("loading")

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]

        config.body = new FormData(this.form)

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((res) => {
            console.log(res)
            if (res.status) {
              console.log("there was an error")
              return
            }

            //Open cart
            window.liquidAjaxCart.update()
            this.cartDrawer.open()
            this.modal.close()
          })
          .catch((e) => {
            console.error(e)
          })
          .finally(() => {
            btn.removeAttribute("aria-disabled")
            btn.classList.remove("loading")
          })
      }
    },
  )
}
